import { Box } from '@mui/material';
import { concat, get } from 'lodash';
import React, { FC, useMemo } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import MUIDownloadFile from '../../../../../../components/ui-component/form-component/form-fields/fields/MUIDownloadFile';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { getUserJwt } from '../../../../../../context/AuthHelper';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { STRAPI_URL } from '../../../../../../lib/constants/url';
import { FormStrucItem } from '../../../../../../lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import VNSchema from '../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VNSchema.attributes;

const BescheidVN: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly, printMode } = useApplication();

	const bescheidPath = VN_P.Allgemein_Generierte_Pruefmitteilung.path;

	const handleDownloadBescheid = async () => {
		await fetchFile(get(application, `${bescheidPath}.attributes.url`), get(application, `${bescheidPath}.attributes.name`));
	};

	const isUploadFieldDisabled = useMemo(() => {
		if (
			// get(application, VN_P.Status_Status.path) === VN_STATUS.PruefmitteilungUebermittelt &&
			!get(application, VN_P.Allgemein_Unterschriebene_Pruefmitteilung.path, '')
		) {
			return false;
		} else {
			return readOnly;
		}
	}, [application, readOnly]);

	return (
		<>
			<ApplicationHeading title='Prüfmitteilung' description={PLATZHALTER_TEXT} />

			<MUIDownloadFile
				fileMetaData={get(application, bescheidPath, {})}
				onDownload={handleDownloadBescheid}
				downloadedOn={get(application, '', null)}
				showDownloadButton={true}
				showDownloadedOn={false}
			/>

			<Box sx={{ mt: '2rem' }}></Box>

			<CreateForm
				formStruc={formStruc()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={isUploadFieldDisabled}
				printMode={printMode}
			/>
		</>
	);
};

export default BescheidVN;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...VN_P.Allgemein_Unterschriebene_Pruefmitteilung,
					label: 'Bitte laden Sie hier den unterschriebenen Bescheid hoch:',
				},
			],
		},
	];
	return struc;
};

export const getFormStrucBescheidVN = () => {
	return concat(formStruc());
};
const fetchFile = async (url: string, fileName: string = '') => {
	try {
		let res = await fetch(`${STRAPI_URL}${url}`, {
			headers: {
				Authorization: `Bearer ${getUserJwt()}`,
			},
		});

		const blob = await res.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = fileName;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	} catch (err: any) {
		console.error(' ERROR: Downloading File ', err);
	}
};
